module.exports = __webpack_public_path__ + "static/img/currentInd.aa7549e9.png";